<template>
  <div class="header-language-select">
    <v-select
      :value="lang"
      :items="languages"
      :menu-props="{
        contentClass: 'header-language-select-menu-list',
        closeOnContentClick: true,
        maxHeight: '90%'
      }"
      append-icon=""
      dense
      hide-details
      item-value="name"
    >
      <template #item="{ item }">
        <v-list-item
          class="header-language-select-item"
          :disabled="item.soon"
          @click="handleChangeLanguage(item.name)"
        >
          <div class="d-flex align-center">
            <div class="header-language-select-language-code">
              {{ item.name | convertToUpper }}
            </div>
            <div class="header-language-select-language-name">
              {{ item.text }}
            </div>
          </div>
          <div
            v-if="item.soon"
            class="header-language-select-soon-btn"
          >
            {{ $t('common.soon') }}
          </div>
        </v-list-item>
      </template>

      <template #selection>
        <div class="header-language-select-language-code">
          {{ lang | convertToUpper }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'
import Cookies from 'js-cookie'
import languages from '@/constants/languges'

moment.locale(localStorage.getItem('i18nLang') || Cookies.get('lang') || 'en')

export default {
  name: 'HeaderLanguageSelector',

  filters: {
    convertToUpper (text) {
      return text.toUpperCase()
    }
  },

  data () {
    return {
      lang: localStorage.getItem('i18nLang') || Cookies.get('lang') || 'en',
      languages,
    }
  },

  computed: {
    ...mapFields('main', ['profile'])
  },

  watch: {
    '$i18n.locale' (val) {
      this.lang = val;
      window.Intercom('update', {
        'interface language': val,
      });
    },

    lang (val) {
      if (this.profileAuthorized) {
        this.api.patch('/profile', { language: val })
      }

      this.profile.language = val
      localStorage.setItem('i18nLang', val)
      this.$vuetify.lang.current = val
      this.$i18n.locale = val
      moment.locale(val)
      this.lang = val
    }
  },

  methods: {
    handleChangeLanguage (newLang) {
      this.lang = newLang
    }
  }
}
</script>

<style lang="scss">
.v-menu__content.theme--light .v-list.v-select-list .v-list-item {
  min-height: 32px;
}

.header-language-select-menu-list {
  min-width: 160px;
  margin-top: 30px;
  margin-left: 0;
  white-space: nowrap;
  background: white;
}

.header-language-select .v-select .v-input__control .v-input__slot:before {
  border: 0;
}

.header-language-select.language-selector .v-input__control .v-select__slot {
  height: 32px;
}

.header-language-select > .v-input {
  margin-top: 1px;
}

.header-language-select.language-selector .v-input--is-focused .v-input__slot:after {
  border: 0;
}

.header-language-select-language-code {
  color: var(--v-old-text-primary-base);
  font-family: Roboto, serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  width: 100%;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-language-select-language-name {
  padding-left: 8px;
  color: var(--v-old-text-secondary-base);
  font-family: Roboto, serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.header-language-select-item .header-language-select-soon-btn {
  font-family: Roboto,serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  height: 20px;
  padding: 0 6px;
  align-items: center;
  gap: 4px;
  color: var(--v-transparent-tag-brand-foreground-default-base);
  background: var(--v-transparent-tag-brand-background-default-base);
  border-radius: 6px;
  margin-left: 16px;
}

.header-language-select-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.header-language-select-item.v-list-item:after {
  display: none;
}

.header-language-select-menu-list .v-list {
  padding: 0;
  overflow: hidden;
}

.header-language-select-menu-list .v-list .v-list-item {
  padding: 8px 12px;
  height: 32px;
}
</style>
